import { apiInstance } from 'common/utils/axios';

export const downloadBulkPDF = async ({ ids }: { ids: string[] }) => {
  const { data } = await apiInstance.post(`/deliveries/pdf-export`, {
    ids
  });
  return data;
};
